// extracted by mini-css-extract-plugin
module.exports = {"tabsContainer":"_482d160"};